export const translations = {
  en: {
    /* ── Navigation ── */
    'nav.dashboard': 'Dashboard', 'nav.goals': 'Goals', 'nav.debt': 'Debt Payoff', 'nav.spending': 'Spending', 'nav.transactions': 'Spending / Income',
    'nav.profile': 'Profile', 'nav.settings': 'Settings',
    /* ── Sidebar ── */
    'sidebar.upgrade': 'Upgrade to Pro ✦', 'sidebar.logout': 'Logout',
    /* ── Theme / Language ── */
    'theme.toggle.dark': '☀️ Light mode', 'theme.toggle.light': '🌙 Dark mode',
    'lang.switch.en': '🇧🇷 Português', 'lang.switch.pt-BR': '🇺🇸 English',
    /* ── Common ── */
    'common.back': '← Back', 'common.next': 'Next →', 'common.save': 'Save Changes',
    'common.saving': 'Saving…', 'common.saved': 'Saved!', 'common.cancel': 'Cancel',
    'common.dismiss': 'Dismiss', 'common.upgrade': 'Upgrade →', 'common.delete': 'Delete',
    'common.go_back': 'Go back', 'common.show_less': 'Show less', 'common.of': 'of',
    'common.entry': 'entry', 'common.entries': 'entries',
    'common.month': 'month', 'common.months': 'months', 'common.total': 'Total',
    /* ── Goal Types ── */
    'goal.type.car': 'Car', 'goal.type.wedding': 'Wedding', 'goal.type.travel': 'Travel',
    'goal.type.electronics': 'Electronics', 'goal.type.emergency': 'Emergency Fund',
    'goal.type.real_estate': 'Real Estate', 'goal.type.education': 'Education',
    'goal.type.custom': 'Custom', 'goal.type.vehicle': 'Vehicle',
    'goal.type.property': 'Property', 'goal.type.emergency_fund': 'Emergency Fund',
    'goal.type.retirement': 'Retirement', 'goal.type.other': 'Other',
    /* ── Goal Status ── */
    'goal.status.active': 'active', 'goal.status.paused': 'paused',
    'goal.status.completed': 'completed', 'goal.status.archived': 'archived',
    /* ── Dashboard ── */
    'dashboard.greeting.morning': 'Good morning', 'dashboard.greeting.afternoon': 'Good afternoon',
    'dashboard.greeting.evening': 'Good evening',
    'dashboard.subtitle': "Here's your financial overview",
    'dashboard.stat.active_goals': 'Active Goals',
    'dashboard.stat.active_goals.sub': 'goals in progress',
    'dashboard.stat.total_saved': 'Total Saved',
    'dashboard.stat.total_saved.sub': 'across all goals',
    'dashboard.stat.monthly_commitment': 'Monthly Commitment',
    'dashboard.stat.monthly_commitment.sub': 'savings target',
    'dashboard.stat.active_plans': 'Active Plans',
    'dashboard.stat.active_plans.sub': 'AI-generated plans',
    'dashboard.goals.title': 'Your Goals',
    'dashboard.goals.manage': 'Manage goals →',
    'dashboard.goals.months_remaining': '{n} months remaining',
    'dashboard.goals.no_plan': 'No plan yet',
    'dashboard.goals.saved': 'saved',
    'dashboard.goals.empty.title': 'No active goals yet',
    'dashboard.goals.empty.sub': 'Create your first financial goal to get started',
    'dashboard.goals.empty.cta': 'Create a goal →',
    'dashboard.goals.view_plan': 'View plan →',
    'dashboard.debts.title': 'Your Debts',
    'dashboard.debts.manage': 'Manage debts →',
    'dashboard.debts.monthly_payment': 'Monthly Payment',
    'dashboard.debts.months_to_payoff': '{n} months to payoff',
    'dashboard.debts.interest_rate': '{n}% interest',
    'dashboard.debts.no_plan': 'No plan yet',
    'dashboard.debts.view_plan': 'View plan →',
    'dashboard.debts.empty.title': 'No active debts',
    'dashboard.debts.empty.sub': 'Add a debt to start planning your payoff strategy',
    'dashboard.debts.empty.cta': 'Add a debt →',
    'dashboard.stat.active_debts': 'Active Debts',
    'dashboard.stat.active_debts.sub': 'debts tracked',
    'dashboard.error': 'Failed to load dashboard. Please refresh.',
    /* ── Goals Page ── */
    'goals.title': 'Financial Goals',
    'goals.subtitle.paid': '{n} active goal',
    'goals.subtitle.paid.plural': '{n} active goals',
    'goals.subtitle.free': '{n} of {limit} free goals used',
    'goals.new': '+ New Goal',
    'goals.new.modal.title': 'New Financial Goal',
    'goals.upgrade.tooltip': 'Upgrade to add more goals',
    'goals.congrats.title': '🎉 Congratulations!',
    'goals.congrats.message': 'You completed "{title}"! Amazing work staying on track.',
    'goals.error.profile': 'You need to set up your financial profile before generating a plan.',
    'goals.error.generate': 'Failed to start plan generation. Please try again.',
    'goals.error.setup_cta': 'Set up profile →',
    'goals.limit.title': 'Free plan limit reached',
    'goals.limit.sub': 'Upgrade to Pro for unlimited goals, advanced scenarios, and more.',
    'goals.limit.cta': 'Upgrade →',
    'goals.empty.title': 'No goals yet',
    'goals.empty.sub': 'Define a financial goal — travel, housing, emergency fund — and let AI build your plan.',
    'goals.empty.cta': 'Create your first goal',
    'goals.section.active': 'Active', 'goals.section.completed': 'Completed',
    'goals.confirm.complete': 'Mark "{title}" as completed?',
    /* ── Goal Card ── */
    'goal.card.congrats.title': 'Goal reached! Congratulations!',
    'goal.card.congrats.both': "You've saved enough and your timeline is complete.",
    'goal.card.congrats.money': "You've saved enough to reach your target.",
    'goal.card.congrats.time': 'Your planned timeline has been completed.',
    'goal.card.congrats.cta': 'Mark it as Done below.',
    'goal.card.completed.badge': 'Goal completed!',
    'goal.card.target_value': 'Target Value',
    'goal.card.ai_estimated': 'AI estimated',
    'goal.card.deadline': 'Deadline: {date}',
    'goal.card.progress.saved': 'Saved', 'goal.card.progress.time': 'Time',
    'goal.card.progress.months': '{elapsed} / {total} months',
    'goal.card.generating': 'Generating...',
    'goal.card.generate': '✦ Generate Plan',
    'goal.card.view_plan': 'View Plan →',
    'goal.card.done': '✓ Done',
    'goal.card.completed_no_plans': '✓ Goal completed — no new plans',
    'goal.card.completed_no_plans.tooltip': 'Completed goals cannot have new plans generated',
    /* ── Goal Form ── */
    'goal.form.type': 'Goal Type',
    'goal.form.type.car': '🚗 Car', 'goal.form.type.wedding': '💍 Wedding',
    'goal.form.type.travel': '✈️ Travel', 'goal.form.type.electronics': '🎮 Electronics',
    'goal.form.type.emergency': '🛡️ Emergency Fund', 'goal.form.type.real_estate': '🏠 Real Estate',
    'goal.form.type.education': '📚 Education', 'goal.form.type.custom': '⭐ Custom',
    'goal.form.title_label': 'Goal Title',
    'goal.form.title_placeholder': 'e.g. Porsche 718 Cayman S',
    'goal.form.description': 'Description (optional)',
    'goal.form.description_placeholder': 'Any additional details...',
    'goal.form.target_amount': 'Target Amount (optional)',
    'goal.form.target_placeholder': 'Leave blank for AI estimate',
    'goal.form.monthly_budget': 'Est. Monthly Budget (optional)',
    'goal.form.monthly_budget_placeholder': 'How much you plan to save/spend',
    'goal.form.deadline': 'Deadline (optional)',
    'goal.form.priority': 'Priority (1 = highest)',
    'goal.form.submit': 'Create Goal',
    'goal.form.type.hint': 'Helps the AI understand the nature of your goal so it can estimate costs and suggest the right savings instruments for your country.',
    'goal.form.title_label.hint': 'Be specific — e.g. "iPhone 16 Pro" instead of "Phone". The AI uses this to look up real market prices when you leave the target amount blank.',
    'goal.form.description.hint': 'Optional extra context for the AI. Mention preferences, constraints, or any detail that affects the cost — e.g. "new, not used" or "trip for 2 people".',
    'goal.form.target_amount.hint': 'The total amount you need to save. Leave blank and the AI will research and estimate the current market price for you.',
    'goal.form.monthly_budget.hint': 'How much you think you can save per month towards this goal. The AI uses this as a reference when sizing your savings plan.',
    'goal.form.deadline.hint': 'Optional target date to reach this goal. The AI will factor it in to calculate if your savings pace is on track.',
    'goal.form.priority.hint': '1 = most important. Used to order your goals and to guide the AI when you have multiple active goals competing for the same budget.',
    /* ── Plan Page ── */
    'plan.generating.title': 'Generating your plan…',
    'plan.generating.sub': 'Our AI is analyzing your profile and building a personalized financial plan. This usually takes 15–30 seconds.',
    'plan.generating.notify': "You'll be notified when it's ready.",
    'plan.generating.back': '← Back to Goals',
    'plan.failed.title': 'Plan generation failed',
    'plan.failed.sub': 'An unexpected error occurred. Please try again.',
    'plan.failed.retry': 'Retry', 'plan.failed.retrying': 'Retrying…',
    'plan.failed.back': 'Back to Goals',
    'plan.failed.load': 'Failed to load plan.',
    'plan.breadcrumb.goals': 'Goals',
    'plan.regenerate': 'Regenerate',
    'plan.regenerate.confirm': 'Regenerate this plan with fresh AI analysis?',
    'plan.regenerate.pro_only': 'Upgrade to Pro to regenerate plans',
    'regen_modal.title': 'Update Information Before Regenerating',
    'regen_modal.use_same': 'Use same information',
    'plan.export_pdf': 'Export PDF',
    'plan.export_pdf.pro_only': 'Upgrade to Pro to export PDFs',
    'plan.stat.cost': 'Effective Cost',
    'plan.stat.cost.ai': 'AI-estimated', 'plan.stat.cost.user': 'User-defined',
    'plan.stat.monthly': 'Monthly Target',
    'plan.stat.monthly.sub': 'to save per month',
    'plan.stat.time': 'Estimated Time', 'plan.stat.time.sub': 'to reach goal',
    'plan.stat.risk': 'Risk Profile', 'plan.stat.risk.sub': 'investment strategy',
    'plan.ai_reasoning': 'AI Reasoning',
    'plan.scenarios.pro_title': 'Scenario Comparison — Pro Feature',
    'plan.scenarios.pro_sub': 'See optimistic, pessimistic, and deadline scenarios side by side.',
    'plan.scenarios.pro_cta': 'Upgrade to Pro →',
    'plan.projection.title': 'Monthly Projection',
    'plan.projection.col.month': '#', 'plan.projection.col.date': 'Date',
    'plan.projection.col.add': 'Monthly Add',
    'plan.projection.col.interest': 'Interest',
    'plan.projection.col.accumulated': 'Accumulated',
    'plan.projection.col.total_saved': 'Total Saved',
    'plan.projection.col.sim_interest': '{name} interest',
    'plan.projection.col.sim_total': '{name} total',
    'plan.projection.hint': '↓ Click 📊 Simulate on an instrument below to see interest projections',
    'plan.projection.show_all': 'Show all {n} months ↓',
    'plan.projection.show_less': 'Show less ↑',
    'plan.projection.now': 'now',
    'plan.progress.title': 'Savings Progress',
    'plan.progress.history': 'View full history →',
    'plan.progress.total': 'Total saved:',
    'plan.progress.log': 'log your next entry',
    'plan.progress.entry': 'entry', 'plan.progress.entries': 'entries',
    /* ── Plan Progress Page ── */
    'progress.breadcrumb.goals': 'Goals', 'progress.breadcrumb': 'Progress',
    'progress.back': '← Back to Plan',
    'progress.stat.cost': 'Goal Cost', 'progress.stat.monthly': 'Monthly Target',
    'progress.stat.deadline': 'Deadline', 'progress.stat.timeline': 'Timeline',
    'progress.stat.timeline.value': '{n} months',
    'progress.bar.saved': 'Saved:', 'progress.bar.of': 'of',
    'progress.form.title': 'Log Progress',
    'progress.form.amount': 'Amount Saved',
    'progress.form.description': 'Description',
    'progress.form.description_placeholder': 'e.g. Cut dining out budget, freelance bonus…',
    'progress.form.submit': 'Save Entry',
    'progress.form.success': 'Entry saved!',
    'progress.form.error.amount': 'Please enter a valid positive amount.',
    'progress.form.error.notes': 'Description is required so you can remember what you saved.',
    'progress.history.title': 'History',
    'progress.history.empty.title': 'No entries yet.',
    'progress.history.empty.sub': 'Log your first savings entry on the left.',
    'progress.history.remove': 'Remove entry',
    'progress.not_found': 'Plan not found.',
    'progress.delete.confirm': 'Remove "{notes}" ({amount})? The cumulative totals will be recalculated.',
    /* ── AI Insights ── */
    'insights.warnings.title': '⚠️ Risk Warnings',
    'insights.recs.title': '✦ AI Recommendations',
    'insights.empty': 'No AI insights available for this plan.',
    'insights.potential_save': 'Potential save',
    'insights.priority': 'Priority:',
    'insights.priority.1': 'Critical', 'insights.priority.2': 'High',
    'insights.priority.3': 'Medium', 'insights.priority.4': 'Low',
    'insights.priority.5': 'Informational',
    'insights.cat.investment': 'Investment',
    'insights.cat.expense_reduction': 'Reduce Expenses',
    'insights.cat.budget_reallocation': 'Budget Reallocation',
    'insights.cat.behavior': 'Behavior Tip',
    /* ── Scenario Chart ── */
    'chart.hint.dashed': 'Dashed lines = investment simulations. Solid lines = AI-generated scenarios.',
    'chart.hint.select': 'Select instruments below to compare growth.',
    'chart.goal': 'Goal',
    /* ── Profile Page ── */
    'profile.title': 'Financial Profile',
    'profile.subtitle': 'Keep your profile up to date so the AI generates accurate plans.',
    'profile.income.title': 'Income & Currency',
    'profile.income.monthly': 'Monthly Net Income',
    'profile.income.savings': 'Current Savings / Available Capital',
    'profile.income.currency': 'Currency',
    'profile.summary.income': 'Income', 'profile.summary.expenses': 'Expenses',
    'profile.summary.disposable': 'Disposable',
    'profile.expenses.title': 'Monthly Expenses',
    'profile.expenses.subtitle': 'Leave a category blank to exclude it.',
    'profile.risk.title': 'Investment Risk Profile',
    'profile.risk.subtitle': 'Determines investment recommendations in your plans.',
    'profile.save': 'Save Changes',
    'profile.success': '✓ Profile saved successfully. Future plans will use these values.',
    'profile.no_profile': '⚠ No profile set up yet — save to enable plan generation.',
    'profile.error.income': 'Monthly income must be greater than zero.',
    'profile.error.save': 'Failed to save profile. Please try again.',
    /* ── Expense Categories ── */
    'expense.cat.housing': ' Housing / Rent', 'expense.cat.food': ' Food & Groceries',
    'expense.cat.transport': ' Transport', 'expense.cat.utilities': ' Utilities',
    'expense.cat.health': ' Health & Insurance', 'expense.cat.entertainment': ' Entertainment',
    'expense.cat.subscriptions': ' Subscriptions', 'expense.cat.education': ' Education',
    'expense.cat.other': ' Other', 'expense.cat.clothing': ' Clothing',
    'expense.cat.personal_care': ' Personal Care', 'expense.cat.investments': ' Investments',
    /* ── Risk Profiles ── */
    'risk.conservative.label': '🛡️ Conservative',
    'risk.conservative.desc': 'Safety first — fixed income instruments',
    'risk.moderate.label': '⚖️ Moderate',
    'risk.moderate.desc': 'Balanced portfolio — mix of fixed and variable income',
    'risk.aggressive.label': '🚀 Aggressive',
    'risk.aggressive.desc': 'Growth-focused — stocks, FIIs, higher volatility',
    /* ── Profile Setup ── */
    'setup.title': 'Set up your financial profile',
    'setup.subtitle': 'This helps the AI create accurate plans for you',
    'setup.confirmed_title': 'Your account has been confirmed!',
    'setup.confirmed_sub': 'Welcome to Plannizzi AI. Complete your profile below to get started.',
    'setup.step1.title': 'Income & Savings',
    'setup.step1.income': 'Monthly Net Income',
    'setup.step1.savings': 'Current Savings',
    'setup.step1.country': 'Country',
    'setup.step1.country_placeholder': 'Select your region',
    'setup.step1.currency': 'Currency',
    'setup.step1.currency_placeholder': 'Select your currency',
    'setup.step2.title': 'Monthly Expenses',
    'setup.step2.subtitle': 'Fill in what applies to you — leave blank to skip',
    'setup.step3.title': 'Risk Profile',
    'setup.step3.subtitle': 'Determines investment recommendations',
    'setup.save': 'Save Profile →',
    'setup.error': 'Failed to save profile',
    /* ── Login ── */
    'login.title': 'Welcome back', 'login.subtitle': 'Sign in to your account',
    'login.email': 'Email', 'login.password': 'Password', 'login.submit': 'Sign In',
    'login.loading': 'Signing in...',
    'login.error': 'Login failed. Please check your credentials.',
    'login.forgot': 'Forgot password?',
    'auth.google': 'Continue with Google', 'auth.or': 'or',
    'login.no_account': "Don't have an account?", 'login.create': 'Create one free',
    /* ── Forgot password ── */
    'forgot.title': 'Forgot your password?', 'forgot.subtitle': "Enter your email and we'll send a reset link.",
    'forgot.email': 'Email', 'forgot.submit': 'Send reset link',
    'forgot.success': 'Check your inbox!',
    'forgot.success_sub': 'If that email is registered, a reset link is on its way. Check your spam folder too.',
    'forgot.back_login': 'Back to login', 'forgot.error': 'Something went wrong. Please try again.',
    /* ── Reset password ── */
    'reset.title': 'Choose a new password', 'reset.subtitle': 'Make it strong — at least 8 characters.',
    'reset.password': 'New password', 'reset.confirm': 'Confirm new password',
    'reset.submit': 'Reset password', 'reset.mismatch': 'Passwords do not match.',
    'reset.invalid_token': 'This reset link is invalid or has expired.',
    'reset.request_new': 'Request a new link', 'reset.done': 'Password reset successfully. Please sign in.',
    /* ── Register ── */
    'register.title': 'Create your account',
    'register.subtitle': 'Free plan — no credit card required',
    'register.name': 'Full Name', 'register.email': 'Email', 'register.password': 'Password',
    'register.password_hint': 'Min 8 chars, 1 uppercase, 1 number',
    'register.country': 'Country', 'register.currency': 'Currency',
    'register.submit': 'Create Account',
    'register.error': 'Registration failed. Please try again.',
    'register.confirm_title': 'Check your inbox!',
    'register.confirm_sub': 'We sent a confirmation link to your email. Click it to activate your account.',

    'register.have_account': 'Already have an account?', 'register.sign_in': 'Sign in',
    'register.country.BR': '🇧🇷 Brazil', 'register.country.US': '🇺🇸 United States',
    'register.country.PT': '🇵🇹 Portugal', 'register.country.OTHER': 'Other',
    /* ── Pricing ── */
    'pricing.title': 'Simple, Honest Pricing',
    'pricing.subtitle': "Start free. Upgrade when you're ready to unlock your full financial potential.",
    'pricing.free.label': 'Free', 'pricing.free.sub': 'Perfect to get started and explore the platform.',
    'pricing.pro.label': 'Pro', 'pricing.pro.sub': 'Full power of AI financial planning — no limits.',
    'pricing.pro.badge': 'Most Popular', 'pricing.month': '/month', 'pricing.year': '/year',
    'pricing.billing.monthly': 'Monthly', 'pricing.billing.yearly': 'Yearly',
    'pricing.billing.save': 'Save {pct}%',
    'pricing.yearly.billed': 'Billed annually',
    'pricing.current_plan': 'Current plan', 'pricing.get_started': 'Get started free',
    'pricing.manage': 'Manage subscription',
    'pricing.upgrade_auth': 'Upgrade to Pro →', 'pricing.upgrade_guest': 'Sign up & upgrade →',
    'pricing.faq.title': 'Frequently Asked Questions',
    'pricing.faq.1.q': 'Can I cancel anytime?',
    'pricing.faq.1.a': 'Yes. You can cancel your subscription at any time from the billing portal. Access remains until the end of the billing period.',
    'pricing.faq.2.q': 'Is my financial data safe?',
    'pricing.faq.2.a': 'All data is encrypted in transit (TLS) and at rest. We never share your data with third parties.',
    'pricing.faq.3.q': 'How does the AI generate plans?',
    'pricing.faq.3.a': 'Our AI engine analyses your income, expenses, risk profile, and financial goals to craft a personalised, month-by-month savings and investment plan — no generic templates, just smart recommendations built around your real numbers.',
    'pricing.faq.4.q': 'What currencies are supported?',
    'pricing.faq.4.a': 'Plannizzi supports BRL (Brazilian Real), USD (US Dollar), and EUR (Euro), with region-specific investment recommendations for Brazil, the United States, Europe, and beyond.',

    'pricing.error.checkout': 'Failed to start checkout. Please try again.',
    'pricing.error.portal': 'Failed to open billing portal.',
    'pricing.feature.free.1': '1 active financial goals',
    'pricing.feature.free.2': '1 AI-generated plans',
    'pricing.feature.free.3': 'Realistic scenario only',
    'pricing.feature.free.4': 'Up to 3 recommendations per plan',
    'pricing.feature.free.5': 'Progress tracking',
    'pricing.feature.free.6': 'Optimistic & pessimistic scenarios',
    'pricing.feature.free.7': 'Deadline scenario simulation',
    'pricing.feature.free.8': 'Unlimited goals & plans',
    'pricing.feature.free.9': 'Full recommendation suite',
    'pricing.feature.free.10': 'Profile history & version tracking',
    'pricing.feature.free.11': 'Priority AI generation',
    'pricing.feature.pro.1': 'Unlimited financial goals',
    'pricing.feature.pro.2': 'Unlimited AI-generated plans',
    'pricing.feature.pro.3': 'All 4 scenario types',
    'pricing.feature.pro.4': 'Full recommendation suite',
    'pricing.feature.pro.5': 'Progress tracking',
    'pricing.feature.pro.6': 'Profile history & version tracking',
    'pricing.feature.pro.7': 'Priority AI generation',
    'pricing.feature.pro.8': 'Advanced investment breakdowns',
    'pricing.feature.pro.9': 'Brazilian market intelligence',
    'pricing.feature.pro.10': 'Export plans to PDF',
    'pricing.feature.pro.11': 'Email plan summaries',
    /* ── Transactions ── */
    'tx.title': 'Daily Spending', 'tx.subtitle': 'Track every expense and income entry',
    'tx.add': '+ Add Transaction', 'tx.cancel': 'Cancel',
    'tx.form.title': 'New Transaction',
    'tx.form.expense': '↑ Expense', 'tx.form.income': '↓ Income',
    'tx.form.amount': 'Amount', 'tx.form.category': 'Category',
    'tx.form.description': 'Description (optional)',
    'tx.form.description_placeholder': 'What was this for?',
    'tx.form.date': 'Date',
    'tx.form.submit.expense': 'Add Expense', 'tx.form.submit.income': 'Add Income',
    'tx.form.error.amount': 'Amount must be greater than 0',
    'tx.form.error.add': 'Failed to add transaction',
    'tx.summary.spent': 'Spent', 'tx.summary.income': 'Income', 'tx.summary.net': 'Net',
    'tx.export_pdf': 'Export PDF',
    'tx.export_pdf.month': 'Export this month',
    'tx.export_pdf.year': 'Export full year',
    'tx.export_pdf.select_year': 'Select year',
    'tx.export_pdf.no_years': 'No data available for export',
    'tx.export_pdf.pro_only': 'Upgrade to Pro to export PDFs',
    'tx.empty.title': 'No transactions for {month}',
    'tx.empty.sub': 'Start adding your daily expenses to track where your money goes.',
    'tx.empty.cta': '+ Add your first transaction',
    'tx.delete.confirm': 'Delete this transaction?',
    'tx.delete.tooltip': 'Delete transaction',
    /* ── Landing ── */
    'landing.nav.pricing': 'Pricing', 'landing.nav.sign_in': 'Sign In',
    'landing.nav.get_started': 'Get Started Free',
    'landing.badge': 'AI-Powered • Free to Start',
    'landing.hero.title1': 'Stop just dreaming.',
    'landing.hero.title2': 'Start building toward it.',
    'landing.hero.sub': 'Most people never reach their financial goals — not because they lack discipline, but because they lack a clear, personalised plan. Plannizzi AI builds that plan for you in seconds.',
    'landing.hero.trust1': '✓ No financial expertise required',
    'landing.hero.trust2': '✓ Ready in under 2 minutes',
    'landing.hero.trust3': '✓ Free plan, no credit card',
    'landing.hero.cta': 'Start for free →', 'landing.hero.pricing': 'See pricing',
    'landing.goal.car': 'Dream Car', 'landing.goal.wedding': 'Wedding',
    'landing.goal.travel': 'Travel', 'landing.goal.electronics': 'Electronics',
    'landing.goal.emergency': 'Emergency Fund', 'landing.goal.real_estate': 'Real Estate',
    'landing.goal.debt': 'Debt Payoff',
    'landing.problem.label': 'Does this sound familiar?',
    'landing.problem.body': 'You know what you want — a home, a car, a trip, a safety net. But between your income, your expenses, and the uncertainty of how much to save... where do you even begin? Millions of people share that feeling. And most give up — not because they cannot afford their dreams, but because no one ever showed them a realistic path to get there.',
    'landing.problem.solution': 'Plannizzi AI changes that.',
    'landing.how.title': 'Your personalised plan in 3 simple steps',
    'landing.how.sub': 'No spreadsheets. No financial jargon. Just a clear roadmap built around your life.',
    'landing.how.step1.label': 'Step 1',
    'landing.how.step1.title': 'Define your goal',
    'landing.how.step1.desc': 'Tell us what you are saving for — a car, a house, a trip, an emergency fund. Be as specific or as broad as you like.',
    'landing.how.step2.label': 'Step 2',
    'landing.how.step2.title': 'Share your finances',
    'landing.how.step2.desc': 'Your income, monthly expenses, and current savings. It takes under two minutes and your data stays private and secure.',
    'landing.how.step3.label': 'Step 3',
    'landing.how.step3.title': 'Get your AI plan',
    'landing.how.step3.desc': 'Receive a month-by-month savings roadmap, investment scenarios, risk analysis, and personalised recommendations — built around your real numbers.',
    'landing.stats.s1.num': 'Seconds',
    'landing.stats.s1.label': 'to generate your full personalised plan',
    'landing.stats.s2.num': 'Month-by-month',
    'landing.stats.s2.label': 'timeline so you always know what to do next',
    'landing.stats.s3.num': '3 scenarios',
    'landing.stats.s3.label': 'optimistic, realistic and conservative projections',
    'landing.features.title': 'Everything you need to reach your goals',
    'landing.features.sub': 'Built for people who are serious about their financial future — without needing a finance degree.',
    'landing.feature.ai.title': 'AI-Powered Planning',
    'landing.feature.ai.desc': 'Tell us your income, expenses, and dream. Our AI builds a realistic, step-by-step savings plan — no spreadsheets, no guesswork.',
    'landing.feature.sim.title': 'Multi-Scenario Simulation',
    'landing.feature.sim.desc': 'See how different investment strategies — from conservative savings to market instruments — change your timeline and final result.',
    'landing.feature.rec.title': 'Smart Recommendations',
    'landing.feature.rec.desc': 'Receive actionable advice on reducing expenses, rebalancing your portfolio, and adjusting your plan as life changes.',
    'landing.feature.track.title': 'Progress Tracking',
    'landing.feature.track.desc': 'Log your monthly savings, watch your progress bar fill up, and stay motivated every step of the way to your goal.',
    'landing.trust.title': 'Real goals. Real results.',
    'landing.trust.sub': 'People just like you are using Plannizzi AI to finally take control of their finances.',
    'landing.trust.t1.quote': 'I had been "saving for a house" for 3 years without a real plan. Within minutes, Plannizzi AI showed me exactly how much to save each month. I finally felt in control.',
    'landing.trust.t1.name': 'Lucas M.',
    'landing.trust.t1.role': 'First-time homebuyer',
    'landing.trust.t2.quote': 'I never thought I could afford my dream trip to Japan. The AI plan gave me a clear 14-month roadmap and I followed it. I leave next month.',
    'landing.trust.t2.name': 'Aline R.',
    'landing.trust.t2.role': 'Travel enthusiast',
    'landing.trust.t3.quote': 'The investment scenarios blew me away. I could see exactly how the Selic rate would change my trajectory — month by month, right there on screen.',
    'landing.trust.t3.name': 'Rafael T.',
    'landing.trust.t3.role': 'Software engineer',
    'landing.cta.title': 'Your goal is closer than you think.',
    'landing.cta.sub': 'Start today. Your future self will thank you.',
    'landing.cta.button': 'Create your free account →',
    'landing.cta.note': 'Free plan · No credit card · Cancel anytime',
    /* ── Landing Debt section ── */
    'landing.debt.badge': 'New — Debt Payoff',
    'landing.debt.title': 'Crush your debt with an AI-powered payoff plan',
    'landing.debt.sub': 'Enter your balance, interest rate, and monthly budget. Plannizzi AI will calculate the fastest, cheapest path to becoming debt-free — and walk you through it month by month.',
    'landing.debt.point.avalanche': 'Avalanche & Snowball strategies explained and compared',
    'landing.debt.point.snowball': 'See exactly how much interest you save vs. minimum payments',
    'landing.debt.point.projection': 'Month-by-month amortization schedule',
    'landing.debt.point.savings': 'Personalised tips to pay off faster',
    'landing.debt.cta': 'Get your debt-free plan →',
    'landing.debt.stat.strategy': 'Strategy', 'landing.debt.stat.strategy_val': 'AI-chosen',
    'landing.debt.stat.months': 'Payoff timeline', 'landing.debt.stat.months_val': 'Month-by-month',
    'landing.debt.stat.interest': 'Interest saved', 'landing.debt.stat.interest_val': 'Maximised',
    'landing.debt.stat.schedule': 'Amortization', 'landing.debt.stat.schedule_val': 'Full schedule',
    'brand.slogan': 'Smart finance planning, powered by AI',
    'landing.footer': '© {year} Plannizzi AI. All rights reserved.',
    /* ── Settings ── */
    'settings.title': 'Account Settings', 'settings.subtitle': 'Manage your account and subscription.',
    'settings.account': 'Account Information', 'settings.name': 'Full Name', 'settings.email': 'Email',
    'settings.save': 'Save Changes', 'settings.saving': 'Saving…', 'settings.saved': 'Saved!',
    'settings.password': 'Change Password', 'settings.current_password': 'Current Password',
    'settings.new_password': 'New Password', 'settings.confirm_password': 'Confirm New Password',
    'settings.update_password': 'Update Password',
    'settings.subscription': 'Subscription',
    'settings.plan.free': 'Free Plan', 'settings.plan.paid': 'Pro Plan',
    'settings.plan.active': 'Active', 'settings.plan.inactive': 'Inactive',
    'settings.plan.renews': 'Renews on', 'settings.plan.cancels': 'Cancels on',
    'settings.upgrade': 'Upgrade to Pro', 'settings.manage': 'Manage Subscription',
    'settings.features.free': 'Free plan includes', 'settings.features.paid': 'Pro plan includes',
    'feature.free.1': '1 financial goal', 'feature.free.2': '1 AI-generated plan',
    'feature.free.3': 'Basic projections (1 scenario)', 'feature.free.4': 'Standard response quality',
    'feature.paid.1': 'Unlimited financial goals', 'feature.paid.2': 'Unlimited AI-generated plans',
    'feature.paid.3': 'Full projections (3 scenarios)', 'feature.paid.4': 'Investment simulation tool',
    'feature.paid.5': 'Progress history tracking', 'feature.paid.6': 'Priority AI response quality',

    /* ── Debt ── */
    'debt.title': 'Debt Payoff', 'debt.new': '+ New Debt',
    'debt.subtitle.paid': '{n} active debt goal(s)',
    'debt.subtitle.free': '{n} of {limit} active debt goals',
    'debt.empty.title': 'No debt goals yet',
    'debt.empty.sub': 'Add a debt and let AI build a personalized payoff plan.',
    'debt.empty.cta': 'Add Debt',
    'debt.section.active': 'Active', 'debt.section.completed': 'Paid Off 🎉',
    'debt.limit.title': 'Free plan limit reached',
    'debt.limit.sub': 'Upgrade to Pro for unlimited debt goals.',
    'debt.limit.cta': 'Upgrade', 'debt.limit.tooltip': 'Upgrade to add more debt goals',
    'debt.confirm.delete': 'Delete "{title}"? This cannot be undone.',
    'debt.confirm.complete': 'Mark "{title}" as paid off?',
    'debt.type.credit_card': 'Credit Card', 'debt.type.personal_loan': 'Personal Loan',
    'debt.type.student_loan': 'Student Loan', 'debt.type.car_loan': 'Car Loan',
    'debt.type.mortgage': 'Mortgage', 'debt.type.medical': 'Medical', 'debt.type.other': 'Other',
    'debt.status.active': 'Active', 'debt.status.completed': 'Paid Off', 'debt.status.archived': 'Archived',
    'debt.card.total_debt': 'Total Debt', 'debt.card.interest_rate': 'Interest Rate',
    'debt.card.min_payment': 'Min. Payment', 'debt.card.payoff_plan': 'Payoff Time',
    'debt.card.months': 'months', 'debt.card.view_plan': 'View Plan →',
    'debt.card.get_plan': 'Get AI Plan →', 'debt.card.generating': 'Generating…',
    'debt.card.complete': 'Mark Paid Off',
    'debt.form.modal_title': 'Add a Debt', 'debt.form.title': 'Label',
    'debt.form.title_placeholder': 'e.g. Visa Credit Card',
    'debt.form.debt_type': 'Debt Type', 'debt.form.total_debt': 'Total Balance Owed',
    'debt.form.interest_rate': 'Annual Interest Rate (%)',
    'debt.form.minimum_payment': 'Minimum Payment / month',
    'debt.form.minimum_payment_hint': 'Leave blank if unknown — AI will calculate.',
    'debt.form.description': 'Notes (optional)',
    'debt.form.description_placeholder': 'Any extra context for the AI…',
    'debt.form.submit': 'Add Debt',
    'debt.plan.back': 'All Debt Goals',
    'debt.plan.at_rate': 'at {rate}% annual interest',
    'debt.plan.not_found': 'Debt goal not found.',
    'debt.plan.empty.title': 'No plan yet',
    'debt.plan.empty.sub': 'Let AI analyze your debt and build a personalized payoff strategy.',
    'debt.plan.generate_cta': 'Generate AI Plan',
    'debt.plan.generating': 'Generating…',
    'debt.plan.generating_title': 'Building your payoff plan…',
    'debt.plan.generating_sub': 'This usually takes under 30 seconds.',
    'debt.plan.failed.title': 'Plan generation failed',
    'debt.plan.failed.sub': 'An error occurred. Please try again.',
    'debt.plan.retry_cta': 'Try Again',
    'debt.plan.regenerate': 'Regenerate plan',
    'debt.plan.regen_modal.title': 'Update Debt Information Before Regenerating',
    'debt.plan.strategy_label': 'Recommended strategy',
    'debt.plan.stat.monthly_payment': 'Monthly Payment',
    'debt.plan.stat.monthly_payment_sub': 'recommended',
    'debt.plan.stat.months_to_payoff': 'Months to Pay Off',
    'debt.plan.stat.months_to_payoff_sub': '≈ {yr} years',
    'debt.plan.stat.total_interest': 'Total Interest',
    'debt.plan.stat.total_interest_sub': 'cost of debt',
    'debt.plan.stat.total_paid': 'Total Paid',
    'debt.plan.stat.total_paid_sub': 'principal + interest',
    'debt.plan.summary.title': 'Plan Summary',
    'debt.plan.recommendations.title': 'Recommendations',
    'debt.plan.warnings.title': 'Risk Warnings',
    'debt.plan.reasoning.title': 'AI Reasoning',
    'debt.plan.table.title': 'Monthly Payoff Schedule',
    'debt.plan.table.months_total': 'months total',
    'debt.plan.table.month': 'Month',
    'debt.plan.table.payment': 'Payment',
    'debt.plan.table.principal': 'Principal',
    'debt.plan.table.interest': 'Interest',
    'debt.plan.table.balance': 'Balance',
    'debt.plan.table.show_all': 'Show all {n} months',
  },

  'pt-BR': {
    /* ── Navigation ── */
    'nav.dashboard': 'Painel', 'nav.goals': 'Metas', 'nav.debt': 'Quitar Dívidas', 'nav.spending': 'Gastos', 'nav.transactions': 'Gastos / Receitas',
    'nav.profile': 'Perfil', 'nav.settings': 'Configurações',
    /* ── Sidebar ── */
    'sidebar.upgrade': 'Assinar Pro ✦', 'sidebar.logout': 'Sair',
    /* ── Theme / Language ── */
    'theme.toggle.dark': '☀️ Modo claro', 'theme.toggle.light': '🌙 Modo escuro',
    'lang.switch.en': '🇧🇷 Português', 'lang.switch.pt-BR': '🇺🇸 English',
    /* ── Common ── */
    'common.back': '← Voltar', 'common.next': 'Próximo →', 'common.save': 'Salvar Alterações',
    'common.saving': 'Salvando…', 'common.saved': 'Salvo!', 'common.cancel': 'Cancelar',
    'common.dismiss': 'Fechar', 'common.upgrade': 'Atualizar →', 'common.delete': 'Excluir',
    'common.go_back': 'Voltar', 'common.show_less': 'Mostrar menos', 'common.of': 'de',
    'common.entry': 'entrada', 'common.entries': 'entradas',
    'common.month': 'mês', 'common.months': 'meses', 'common.total': 'Total',
    /* ── Goal Types ── */
    'goal.type.car': 'Carro', 'goal.type.wedding': 'Casamento', 'goal.type.travel': 'Viagem',
    'goal.type.electronics': 'Eletrônicos', 'goal.type.emergency': 'Reserva de Emergência',
    'goal.type.real_estate': 'Imóvel', 'goal.type.education': 'Educação',
    'goal.type.custom': 'Personalizado', 'goal.type.vehicle': 'Veículo',
    'goal.type.property': 'Imóvel', 'goal.type.emergency_fund': 'Reserva de Emergência',
    'goal.type.retirement': 'Aposentadoria', 'goal.type.other': 'Outro',
    /* ── Goal Status ── */
    'goal.status.active': 'ativa', 'goal.status.paused': 'pausada',
    'goal.status.completed': 'concluída', 'goal.status.archived': 'arquivada',
    /* ── Dashboard ── */
    'dashboard.greeting.morning': 'Bom dia', 'dashboard.greeting.afternoon': 'Boa tarde',
    'dashboard.greeting.evening': 'Boa noite',
    'dashboard.subtitle': 'Aqui está seu resumo financeiro',
    'dashboard.stat.active_goals': 'Metas Ativas',
    'dashboard.stat.active_goals.sub': 'metas em andamento',
    'dashboard.stat.total_saved': 'Total Poupado',
    'dashboard.stat.total_saved.sub': 'em todas as metas',
    'dashboard.stat.monthly_commitment': 'Compromisso Mensal',
    'dashboard.stat.monthly_commitment.sub': 'meta de poupança',
    'dashboard.stat.active_plans': 'Planos Ativos',
    'dashboard.stat.active_plans.sub': 'planos gerados por IA',
    'dashboard.goals.title': 'Suas Metas',
    'dashboard.goals.manage': 'Gerenciar metas →',
    'dashboard.goals.months_remaining': '{n} meses restantes',
    'dashboard.goals.no_plan': 'Sem plano',
    'dashboard.goals.saved': 'poupado',
    'dashboard.goals.empty.title': 'Nenhuma meta ativa ainda',
    'dashboard.goals.empty.sub': 'Crie sua primeira meta financeira para começar',
    'dashboard.goals.empty.cta': 'Criar uma meta →',
    'dashboard.goals.view_plan': 'Ver plano →',
    'dashboard.debts.title': 'Suas Dívidas',
    'dashboard.debts.manage': 'Gerenciar dívidas →',
    'dashboard.debts.monthly_payment': 'Pagamento Mensal',
    'dashboard.debts.months_to_payoff': '{n} meses para quitar',
    'dashboard.debts.interest_rate': '{n}% de juros',
    'dashboard.debts.no_plan': 'Sem plano',
    'dashboard.debts.view_plan': 'Ver plano →',
    'dashboard.debts.empty.title': 'Nenhuma dívida ativa',
    'dashboard.debts.empty.sub': 'Adicione uma dívida para começar a planejar sua quitação',
    'dashboard.debts.empty.cta': 'Adicionar dívida →',
    'dashboard.stat.active_debts': 'Dívidas Ativas',
    'dashboard.stat.active_debts.sub': 'dívidas monitoradas',
    'dashboard.error': 'Falha ao carregar painel. Por favor atualize.',
    /* ── Goals Page ── */
    'goals.title': 'Metas Financeiras',
    'goals.subtitle.paid': '{n} meta ativa',
    'goals.subtitle.paid.plural': '{n} metas ativas',
    'goals.subtitle.free': '{n} de {limit} metas gratuitas usadas',
    'goals.new': '+ Nova Meta',
    'goals.new.modal.title': 'Nova Meta Financeira',
    'goals.upgrade.tooltip': 'Faça upgrade para adicionar mais metas',
    'goals.congrats.title': '🎉 Parabéns!',
    'goals.congrats.message': 'Você concluiu "{title}"! Excelente trabalho!',
    'goals.error.profile': 'Você precisa configurar seu perfil financeiro antes de gerar um plano.',
    'goals.error.generate': 'Falha ao iniciar geração do plano. Tente novamente.',
    'goals.error.setup_cta': 'Configurar perfil →',
    'goals.limit.title': 'Limite do plano gratuito atingido',
    'goals.limit.sub': 'Assine o Pro para metas ilimitadas, cenários avançados e mais.',
    'goals.limit.cta': 'Fazer upgrade →',
    'goals.empty.title': 'Nenhuma meta ainda',
    'goals.empty.sub': 'Defina uma meta — viagem, imóvel, reserva de emergência — e deixe a IA montar seu plano.',
    'goals.empty.cta': 'Criar sua primeira meta',
    'goals.section.active': 'Ativas', 'goals.section.completed': 'Concluídas',
    'goals.confirm.complete': 'Marcar "{title}" como concluída?',
    /* ── Goal Card ── */
    'goal.card.congrats.title': 'Meta atingida! Parabéns!',
    'goal.card.congrats.both': 'Você poupou o suficiente e seu prazo foi concluído.',
    'goal.card.congrats.money': 'Você poupou o suficiente para atingir sua meta.',
    'goal.card.congrats.time': 'Seu prazo planejado foi concluído.',
    'goal.card.congrats.cta': 'Marque como Concluída abaixo.',
    'goal.card.completed.badge': 'Meta concluída!',
    'goal.card.target_value': 'Valor Alvo',
    'goal.card.ai_estimated': 'Estimado pela IA',
    'goal.card.deadline': 'Prazo: {date}',
    'goal.card.progress.saved': 'Poupado', 'goal.card.progress.time': 'Tempo',
    'goal.card.progress.months': '{elapsed} / {total} meses',
    'goal.card.generating': 'Gerando...',
    'goal.card.generate': '✦ Gerar Plano',
    'goal.card.view_plan': 'Ver Plano →',
    'goal.card.done': '✓ Concluir',
    'goal.card.completed_no_plans': '✓ Meta concluída — sem novos planos',
    'goal.card.completed_no_plans.tooltip': 'Metas concluídas não podem ter novos planos',
    /* ── Goal Form ── */
    'goal.form.type': 'Tipo de Meta',
    'goal.form.type.car': '🚗 Carro', 'goal.form.type.wedding': '💍 Casamento',
    'goal.form.type.travel': '✈️ Viagem', 'goal.form.type.electronics': '🎮 Eletrônicos',
    'goal.form.type.emergency': '🛡️ Reserva de Emergência', 'goal.form.type.real_estate': '🏠 Imóvel',
    'goal.form.type.education': '📚 Educação', 'goal.form.type.custom': '⭐ Personalizado',
    'goal.form.title_label': 'Título da Meta',
    'goal.form.title_placeholder': 'ex: Porsche 718 Cayman S',
    'goal.form.description': 'Descrição (opcional)',
    'goal.form.description_placeholder': 'Detalhes adicionais...',
    'goal.form.target_amount': 'Valor Alvo (opcional)',
    'goal.form.target_placeholder': 'Deixe em branco para estimativa da IA',
    'goal.form.monthly_budget': 'Orçamento Mensal Estimado (opcional)',
    'goal.form.monthly_budget_placeholder': 'Quanto planeja poupar/gastar',
    'goal.form.deadline': 'Prazo (opcional)',
    'goal.form.priority': 'Prioridade (1 = mais alta)',
    'goal.form.submit': 'Criar Meta',
    'goal.form.type.hint': 'Ajuda a IA a entender a natureza da sua meta para estimar custos e sugerir os instrumentos de investimento certos para o seu país.',
    'goal.form.title_label.hint': 'Seja específico — ex: "iPhone 16 Pro" em vez de "Celular". A IA usa isso para pesquisar preços reais de mercado quando você deixa o valor alvo em branco.',
    'goal.form.description.hint': 'Contexto adicional opcional para a IA. Mencione preferências, restrições ou detalhes que afetam o custo — ex: "novo, não usado" ou "viagem para 2 pessoas".',
    'goal.form.target_amount.hint': 'O valor total que você precisa poupar. Deixe em branco e a IA vai pesquisar e estimar o preço atual de mercado para você.',
    'goal.form.monthly_budget.hint': 'Quanto você acha que pode poupar por mês para essa meta. A IA usa isso como referência ao montar o seu plano de poupança.',
    'goal.form.deadline.hint': 'Data limite opcional para atingir essa meta. A IA vai considerar o prazo para calcular se o seu ritmo de poupança está no caminho certo.',
    'goal.form.priority.hint': '1 = mais importante. Usado para ordenar suas metas e orientar a IA quando há várias metas ativas competindo pelo mesmo orçamento.',
    /* ── Plan Page ── */
    'plan.generating.title': 'Gerando seu plano…',
    'plan.generating.sub': 'Nossa IA está analisando seu perfil e criando um plano financeiro personalizado. Isso geralmente leva 15–30 segundos.',
    'plan.generating.notify': 'Você será notificado quando estiver pronto.',
    'plan.generating.back': '← Voltar às Metas',
    'plan.failed.title': 'Falha na geração do plano',
    'plan.failed.sub': 'Ocorreu um erro inesperado. Por favor tente novamente.',
    'plan.failed.retry': 'Tentar Novamente', 'plan.failed.retrying': 'Tentando…',
    'plan.failed.back': 'Voltar às Metas',
    'plan.failed.load': 'Falha ao carregar plano.',
    'plan.breadcrumb.goals': 'Metas',
    'plan.regenerate': 'Regenerar',
    'plan.regenerate.confirm': 'Regenerar este plano com uma nova análise de IA?',
    'plan.regenerate.pro_only': 'Assine o Pro para regenerar planos',
    'regen_modal.title': 'Atualizar Informações Antes de Regenerar',
    'regen_modal.use_same': 'Usar as mesmas informações',
    'plan.export_pdf': 'Exportar PDF',
    'plan.export_pdf.pro_only': 'Assine o Pro para exportar PDFs',
    'plan.stat.cost': 'Custo Efetivo',
    'plan.stat.cost.ai': 'Estimado pela IA', 'plan.stat.cost.user': 'Definido pelo usuário',
    'plan.stat.monthly': 'Meta Mensal', 'plan.stat.monthly.sub': 'a poupar por mês',
    'plan.stat.time': 'Tempo Estimado', 'plan.stat.time.sub': 'para atingir a meta',
    'plan.stat.risk': 'Perfil de Risco', 'plan.stat.risk.sub': 'estratégia de investimento',
    'plan.ai_reasoning': 'Raciocínio da IA',
    'plan.scenarios.pro_title': 'Comparação de Cenários — Recurso Pro',
    'plan.scenarios.pro_sub': 'Veja cenários otimista, pessimista e de prazo lado a lado.',
    'plan.scenarios.pro_cta': 'Assinar Pro →',
    'plan.projection.title': 'Projeção Mensal',
    'plan.projection.col.month': '#', 'plan.projection.col.date': 'Data',
    'plan.projection.col.add': 'Adição Mensal',
    'plan.projection.col.interest': 'Juros',
    'plan.projection.col.accumulated': 'Acumulado',
    'plan.projection.col.total_saved': 'Total Poupado',
    'plan.projection.col.sim_interest': '{name} juros',
    'plan.projection.col.sim_total': '{name} total',
    'plan.projection.hint': '↓ Clique em 📊 Simular em um instrumento abaixo para ver projeções com juros',
    'plan.projection.show_all': 'Ver todos os {n} meses ↓',
    'plan.projection.show_less': 'Ver menos ↑',
    'plan.projection.now': 'agora',
    'plan.progress.title': 'Progresso de Poupança',
    'plan.progress.history': 'Ver histórico completo →',
    'plan.progress.total': 'Total poupado:',
    'plan.progress.log': 'registrar próxima entrada',
    'plan.progress.entry': 'entrada', 'plan.progress.entries': 'entradas',
    /* ── Plan Progress Page ── */
    'progress.breadcrumb.goals': 'Metas', 'progress.breadcrumb': 'Progresso',
    'progress.back': '← Voltar ao Plano',
    'progress.stat.cost': 'Custo da Meta', 'progress.stat.monthly': 'Meta Mensal',
    'progress.stat.deadline': 'Prazo', 'progress.stat.timeline': 'Cronograma',
    'progress.stat.timeline.value': '{n} meses',
    'progress.bar.saved': 'Poupado:', 'progress.bar.of': 'de',
    'progress.form.title': 'Registrar Progresso',
    'progress.form.amount': 'Valor Poupado',
    'progress.form.description': 'Descrição',
    'progress.form.description_placeholder': 'ex: Cortei gastos com restaurante, bônus freelance…',
    'progress.form.submit': 'Salvar Entrada',
    'progress.form.success': 'Entrada salva!',
    'progress.form.error.amount': 'Por favor insira um valor positivo válido.',
    'progress.form.error.notes': 'A descrição é obrigatória para lembrar o que poupou.',
    'progress.history.title': 'Histórico',
    'progress.history.empty.title': 'Nenhuma entrada ainda.',
    'progress.history.empty.sub': 'Registre sua primeira entrada à esquerda.',
    'progress.history.remove': 'Remover entrada',
    'progress.not_found': 'Plano não encontrado.',
    'progress.delete.confirm': 'Remover "{notes}" ({amount})? Os totais acumulados serão recalculados.',
    /* ── AI Insights ── */
    'insights.warnings.title': '⚠️ Avisos de Risco',
    'insights.recs.title': '✦ Recomendações da IA',
    'insights.empty': 'Nenhum insight de IA disponível para este plano.',
    'insights.potential_save': 'Economia potencial',
    'insights.priority': 'Prioridade:',
    'insights.priority.1': 'Crítica', 'insights.priority.2': 'Alta',
    'insights.priority.3': 'Média', 'insights.priority.4': 'Baixa',
    'insights.priority.5': 'Informativo',
    'insights.cat.investment': 'Investimento',
    'insights.cat.expense_reduction': 'Reduzir Gastos',
    'insights.cat.budget_reallocation': 'Realocar Orçamento',
    'insights.cat.behavior': 'Dica de Comportamento',
    /* ── Scenario Chart ── */
    'chart.hint.dashed': 'Linhas tracejadas = simulações de investimento. Linhas sólidas = cenários da IA.',
    'chart.hint.select': 'Selecione instrumentos abaixo para comparar crescimento.',
    'chart.goal': 'Meta',
    /* ── Profile Page ── */
    'profile.title': 'Perfil Financeiro',
    'profile.subtitle': 'Mantenha seu perfil atualizado para que a IA gere planos precisos.',
    'profile.income.title': 'Renda e Moeda',
    'profile.income.monthly': 'Renda Líquida Mensal',
    'profile.income.savings': 'Poupança Atual / Capital Disponível',
    'profile.income.currency': 'Moeda',
    'profile.summary.income': 'Renda', 'profile.summary.expenses': 'Gastos',
    'profile.summary.disposable': 'Disponível',
    'profile.expenses.title': 'Despesas Mensais',
    'profile.expenses.subtitle': 'Deixe em branco para excluir a categoria.',
    'profile.risk.title': 'Perfil de Risco de Investimento',
    'profile.risk.subtitle': 'Determina as recomendações de investimento nos seus planos.',
    'profile.save': 'Salvar Alterações',
    'profile.success': '✓ Perfil salvo com sucesso. Planos futuros usarão esses valores.',
    'profile.no_profile': '⚠ Nenhum perfil configurado — salve para habilitar a geração de planos.',
    'profile.error.income': 'A renda mensal deve ser maior que zero.',
    'profile.error.save': 'Falha ao salvar perfil. Por favor tente novamente.',
    /* ── Expense Categories ── */
    'expense.cat.housing': ' Moradia / Aluguel', 'expense.cat.food': ' Alimentação',
    'expense.cat.transport': ' Transporte', 'expense.cat.utilities': ' Contas / Serviços',
    'expense.cat.health': ' Saúde e Plano', 'expense.cat.entertainment': ' Entretenimento',
    'expense.cat.subscriptions': ' Assinaturas', 'expense.cat.education': ' Educação',
    'expense.cat.other': ' Outros', 'expense.cat.clothing': ' Roupas',
    'expense.cat.personal_care': ' Cuidados Pessoais', 'expense.cat.investments': ' Investimentos',
    /* ── Risk Profiles ── */
    'risk.conservative.label': '🛡️ Conservador',
    'risk.conservative.desc': 'Segurança em primeiro lugar — renda fixa',
    'risk.moderate.label': '⚖️ Moderado',
    'risk.moderate.desc': 'Carteira equilibrada — mix de renda fixa e variável',
    'risk.aggressive.label': '🚀 Arrojado',
    'risk.aggressive.desc': 'Foco em crescimento — ações, FIIs, maior volatilidade',
    /* ── Profile Setup ── */
    'setup.title': 'Configure seu perfil financeiro',
    'setup.subtitle': 'Isso ajuda a IA a criar planos precisos para você',
    'setup.confirmed_title': 'Sua conta foi confirmada!',
    'setup.confirmed_sub': 'Bem-vindo ao Plannizzi AI. Complete seu perfil abaixo para começar.',
    'setup.step1.title': 'Renda e Poupança',
    'setup.step1.income': 'Renda Líquida Mensal',
    'setup.step1.savings': 'Poupança Atual',
    'setup.step1.country': 'País',
    'setup.step1.country_placeholder': 'Selecione seu país',
    'setup.step1.currency': 'Moeda',
    'setup.step1.currency_placeholder': 'Selecione sua moeda',
    'setup.step2.title': 'Despesas Mensais',
    'setup.step2.subtitle': 'Preencha o que se aplica — deixe em branco para pular',
    'setup.step3.title': 'Perfil de Risco',
    'setup.step3.subtitle': 'Determina as recomendações de investimento',
    'setup.save': 'Salvar Perfil →',
    'setup.error': 'Falha ao salvar perfil',
    /* ── Login ── */
    'login.title': 'Bem-vindo de volta', 'login.subtitle': 'Entre na sua conta',
    'login.email': 'E-mail', 'login.password': 'Senha', 'login.submit': 'Entrar',
    'login.loading': 'Entrando...',
    'login.error': 'Falha no login. Verifique suas credenciais.',
    'login.forgot': 'Esqueceu a senha?',
    'auth.google': 'Continuar com Google', 'auth.or': 'ou',
    'login.no_account': 'Não tem uma conta?', 'login.create': 'Crie uma gratuitamente',
    /* ── Forgot password ── */
    'forgot.title': 'Esqueceu sua senha?', 'forgot.subtitle': 'Informe seu e-mail e enviaremos um link de redefinição.',
    'forgot.email': 'E-mail', 'forgot.submit': 'Enviar link de redefinição',
    'forgot.success': 'Verifique sua caixa de entrada!',
    'forgot.success_sub': 'Se esse e-mail estiver cadastrado, o link já está a caminho. Verifique também o spam.',
    'forgot.back_login': 'Voltar ao login', 'forgot.error': 'Algo deu errado. Tente novamente.',
    /* ── Reset password ── */
    'reset.title': 'Escolha uma nova senha', 'reset.subtitle': 'Use pelo menos 8 caracteres, 1 maiúscula e 1 número.',
    'reset.password': 'Nova senha', 'reset.confirm': 'Confirme a nova senha',
    'reset.submit': 'Redefinir senha', 'reset.mismatch': 'As senhas não coincidem.',
    'reset.invalid_token': 'Este link de redefinição é inválido ou expirou.',
    'reset.request_new': 'Solicitar novo link', 'reset.done': 'Senha redefinida com sucesso. Faça login.',
    /* ── Register ── */
    'register.title': 'Crie sua conta',
    'register.subtitle': 'Plano gratuito — sem cartão de crédito',
    'register.name': 'Nome Completo', 'register.email': 'E-mail', 'register.password': 'Senha',
    'register.password_hint': 'Mín. 8 caracteres, 1 maiúscula, 1 número',
    'register.country': 'País', 'register.currency': 'Moeda',
    'register.submit': 'Criar Conta',
    'register.error': 'Falha no cadastro. Por favor tente novamente.',
    'register.confirm_title': 'Verifique sua caixa de entrada!',
    'register.confirm_sub': 'Enviamos um link de confirmação para seu e-mail. Clique nele para ativar sua conta.',

    'register.have_account': 'Já tem uma conta?', 'register.sign_in': 'Entrar',
    'register.country.BR': '🇧🇷 Brasil', 'register.country.US': '🇺🇸 Estados Unidos',
    'register.country.PT': '🇵🇹 Portugal', 'register.country.OTHER': 'Outro',
    /* ── Pricing ── */
    'pricing.title': 'Preços Simples e Transparentes',
    'pricing.subtitle': 'Comece grátis. Faça upgrade quando quiser desbloquear todo o seu potencial financeiro.',
    'pricing.free.label': 'Gratuito', 'pricing.free.sub': 'Perfeito para começar e explorar a plataforma.',
    'pricing.pro.label': 'Pro', 'pricing.pro.sub': 'Todo o poder do planejamento financeiro com IA — sem limites.',
    'pricing.pro.badge': 'Mais Popular', 'pricing.month': '/mês', 'pricing.year': '/ano',
    'pricing.billing.monthly': 'Mensal', 'pricing.billing.yearly': 'Anual',
    'pricing.billing.save': 'Economize {pct}%',
    'pricing.yearly.billed': 'Cobrado anualmente',
    'pricing.current_plan': 'Plano atual', 'pricing.get_started': 'Começar gratuitamente',
    'pricing.manage': 'Gerenciar assinatura',
    'pricing.upgrade_auth': 'Assinar Pro →', 'pricing.upgrade_guest': 'Cadastrar e assinar →',
    'pricing.faq.title': 'Perguntas Frequentes',
    'pricing.faq.1.q': 'Posso cancelar a qualquer momento?',
    'pricing.faq.1.a': 'Sim. Você pode cancelar sua assinatura a qualquer momento pelo portal de cobrança. O acesso permanece até o fim do período.',
    'pricing.faq.2.q': 'Meus dados financeiros estão seguros?',
    'pricing.faq.2.a': 'Todos os dados são criptografados em trânsito (TLS) e em repouso. Nunca compartilhamos seus dados com terceiros.',
    'pricing.faq.3.q': 'Como a IA gera planos?',
    'pricing.faq.3.a': 'Nossa IA analisa sua renda, despesas, perfil de risco e objetivos financeiros para criar um plano de poupança e investimento personalizado, mês a mês — sem modelos genéricos, apenas recomendações inteligentes construídas a partir dos seus números reais.',
    'pricing.faq.4.q': 'Quais moedas são suportadas?',
    'pricing.faq.4.a': 'O Plannizzi suporta BRL (Real Brasileiro), USD (Dólar Americano) e EUR (Euro), com recomendações de investimentos específicas para Brasil, Estados Unidos, Europa e outros mercados.',

    'pricing.error.checkout': 'Falha ao iniciar pagamento. Por favor tente novamente.',
    'pricing.error.portal': 'Falha ao abrir portal de cobrança.',
    'pricing.feature.free.1': '1 meta financeira ativa',
    'pricing.feature.free.2': '1 plano gerado por IA',
    'pricing.feature.free.3': 'Apenas cenário realista',
    'pricing.feature.free.4': 'Até 3 recomendações por plano',
    'pricing.feature.free.5': 'Acompanhamento de progresso',
    'pricing.feature.free.6': 'Cenários otimista e pessimista',
    'pricing.feature.free.7': 'Simulação de cenário por prazo',
    'pricing.feature.free.8': 'Metas e planos ilimitados',
    'pricing.feature.free.9': 'Suite completa de recomendações',
    'pricing.feature.free.10': 'Histórico e versões do perfil',
    'pricing.feature.free.11': 'Geração de IA prioritária',
    'pricing.feature.pro.1': 'Metas financeiras ilimitadas',
    'pricing.feature.pro.2': 'Planos por IA ilimitados',
    'pricing.feature.pro.3': 'Todos os 4 tipos de cenário',
    'pricing.feature.pro.4': 'Suite completa de recomendações',
    'pricing.feature.pro.5': 'Acompanhamento de progresso',
    'pricing.feature.pro.6': 'Histórico e versões do perfil',
    'pricing.feature.pro.7': 'Geração de IA prioritária',
    'pricing.feature.pro.8': 'Análises detalhadas de investimentos',
    'pricing.feature.pro.9': 'Inteligência do mercado brasileiro',
    'pricing.feature.pro.10': 'Exportar planos em PDF',
    'pricing.feature.pro.11': 'Resumos por e-mail',
    /* ── Transactions ── */
    'tx.title': 'Gastos Diários', 'tx.subtitle': 'Registre cada despesa e receita',
    'tx.add': '+ Adicionar Transação', 'tx.cancel': 'Cancelar',
    'tx.form.title': 'Nova Transação',
    'tx.form.expense': '↑ Despesa', 'tx.form.income': '↓ Receita',
    'tx.form.amount': 'Valor', 'tx.form.category': 'Categoria',
    'tx.form.description': 'Descrição (opcional)',
    'tx.form.description_placeholder': 'Para que foi isso?',
    'tx.form.date': 'Data',
    'tx.form.submit.expense': 'Adicionar Despesa', 'tx.form.submit.income': 'Adicionar Receita',
    'tx.form.error.amount': 'O valor deve ser maior que 0',
    'tx.form.error.add': 'Falha ao adicionar transação',
    'tx.summary.spent': 'Gasto', 'tx.summary.income': 'Receita', 'tx.summary.net': 'Saldo',
    'tx.export_pdf': 'Exportar PDF',
    'tx.export_pdf.month': 'Exportar este mês',
    'tx.export_pdf.year': 'Exportar ano completo',
    'tx.export_pdf.select_year': 'Selecionar ano',
    'tx.export_pdf.no_years': 'Sem dados disponíveis para exportar',
    'tx.export_pdf.pro_only': 'Assine o Pro para exportar PDFs',
    'tx.empty.title': 'Nenhuma transação em {month}',
    'tx.empty.sub': 'Comece a registrar suas despesas diárias para saber onde seu dinheiro vai.',
    'tx.empty.cta': '+ Adicionar primeira transação',
    'tx.delete.confirm': 'Excluir esta transação?',
    'tx.delete.tooltip': 'Excluir transação',
    /* ── Landing ── */
    'landing.nav.pricing': 'Preços', 'landing.nav.sign_in': 'Entrar',
    'landing.nav.get_started': 'Começar Grátis',
    'landing.badge': 'IA Integrada • Grátis para Começar',
    'landing.hero.title1': 'Pare de só sonhar.',
    'landing.hero.title2': 'Comece a construir de verdade.',
    'landing.hero.sub': 'A maioria das pessoas nunca alcança suas metas financeiras — não por falta de disciplina, mas por falta de um plano claro e personalizado. O Plannizzi AI monta esse plano para você em segundos.',
    'landing.hero.trust1': '✓ Sem necessidade de conhecimento financeiro',
    'landing.hero.trust2': '✓ Pronto em menos de 2 minutos',
    'landing.hero.trust3': '✓ Plano gratuito, sem cartão de crédito',
    'landing.hero.cta': 'Começar gratuitamente →', 'landing.hero.pricing': 'Ver preços',
    'landing.goal.car': 'Carro dos Sonhos', 'landing.goal.wedding': 'Casamento',
    'landing.goal.travel': 'Viagem', 'landing.goal.electronics': 'Eletrônicos',
    'landing.goal.emergency': 'Reserva de Emergência', 'landing.goal.real_estate': 'Imóvel',
    'landing.goal.debt': 'Quitar Dívidas',
    'landing.problem.label': 'Você já se sentiu assim?',
    'landing.problem.body': 'Você sabe o que quer — uma casa, um carro, uma viagem, uma reserva de emergência. Mas entre a sua renda, seus gastos e a dúvida de quanto poupar... por onde começar? Milhões de pessoas sentem o mesmo. E a maioria desiste — não porque não pode realizar seus sonhos, mas porque ninguém nunca mostrou um caminho real para chegar lá.',
    'landing.problem.solution': 'O Plannizzi AI muda isso.',
    'landing.how.title': 'Seu plano personalizado em 3 passos simples',
    'landing.how.sub': 'Sem planilhas. Sem jargão financeiro. Só um roteiro claro construído em torno da sua vida.',
    'landing.how.step1.label': 'Passo 1',
    'landing.how.step1.title': 'Defina sua meta',
    'landing.how.step1.desc': 'Diga o que você está poupando — um carro, uma casa, uma viagem, uma reserva de emergência. Seja tão específico ou amplo quanto quiser.',
    'landing.how.step2.label': 'Passo 2',
    'landing.how.step2.title': 'Compartilhe suas finanças',
    'landing.how.step2.desc': 'Sua renda, gastos mensais e poupança atual. Leva menos de dois minutos e seus dados ficam privados e seguros.',
    'landing.how.step3.label': 'Passo 3',
    'landing.how.step3.title': 'Receba seu plano com IA',
    'landing.how.step3.desc': 'Um roteiro mês a mês, cenários de investimento, análise de risco e recomendações personalizadas — tudo baseado nos seus números reais.',
    'landing.stats.s1.num': 'Segundos',
    'landing.stats.s1.label': 'para gerar seu plano personalizado completo',
    'landing.stats.s2.num': 'Mês a mês',
    'landing.stats.s2.label': 'cronograma para você sempre saber o próximo passo',
    'landing.stats.s3.num': '3 cenários',
    'landing.stats.s3.label': 'projeções otimista, realista e conservadora',
    'landing.features.title': 'Tudo que você precisa para alcançar suas metas',
    'landing.features.sub': 'Criado para quem leva a sério o futuro financeiro — sem precisar de formação em finanças.',
    'landing.feature.ai.title': 'Planejamento com IA',
    'landing.feature.ai.desc': 'Informe sua renda, gastos e sonho. Nossa IA monta um plano de poupança realista, passo a passo — sem planilhas, sem achismos.',
    'landing.feature.sim.title': 'Simulação Multi-Cenário',
    'landing.feature.sim.desc': 'Veja como diferentes estratégias de investimento — da poupança ao mercado financeiro — alteram seu prazo e resultado final.',
    'landing.feature.rec.title': 'Recomendações Inteligentes',
    'landing.feature.rec.desc': 'Receba orientações práticas para reduzir gastos, rebalancear sua carteira e ajustar o plano conforme a vida muda.',
    'landing.feature.track.title': 'Acompanhamento de Progresso',
    'landing.feature.track.desc': 'Registre suas poupanças mensais, acompanhe o progresso e mantenha a motivação em cada passo rumo à sua meta.',
    'landing.trust.title': 'Metas reais. Resultados reais.',
    'landing.trust.sub': 'Pessoas como você estão usando o Plannizzi AI para finalmente assumir o controle das suas finanças.',
    'landing.trust.t1.quote': 'Fazia 3 anos que eu "estava economizando para uma casa" sem nenhum plano real. Em minutos, o Plannizzi AI me mostrou exatamente quanto precisava poupar por mês. Finalmente me senti no controle.',
    'landing.trust.t1.name': 'Lucas M.',
    'landing.trust.t1.role': 'Futuro proprietário',
    'landing.trust.t2.quote': 'Nunca pensei que conseguiria pagar minha viagem dos sonhos para o Japão. O plano da IA me deu um roteiro claro de 14 meses e eu segui. Embarco no mês que vem.',
    'landing.trust.t2.name': 'Aline R.',
    'landing.trust.t2.role': 'Apaixonada por viagens',
    'landing.trust.t3.quote': 'Os cenários de investimento me surpreenderam. Consegui ver exatamente como a Selic mudaria minha trajetória — mês a mês, ali na tela.',
    'landing.trust.t3.name': 'Rafael T.',
    'landing.trust.t3.role': 'Engenheiro de software',
    'landing.cta.title': 'Seu sonho está mais perto do que você imagina.',
    'landing.cta.sub': 'Comece hoje. Seu eu do futuro vai agradecer.',
    'landing.cta.button': 'Criar sua conta gratuita →',
    'landing.cta.note': 'Plano gratuito · Sem cartão de crédito · Cancele quando quiser',
    /* ── Landing Debt section ── */
    'landing.debt.badge': 'Novo — Quitar Dívidas',
    'landing.debt.title': 'Quite sua dívida com um plano gerado por IA',
    'landing.debt.sub': 'Informe seu saldo, taxa de juros e orçamento mensal. O Plannizzi AI calcula o caminho mais rápido e barato para você ficar livre das dívidas — mês a mês.',
    'landing.debt.point.avalanche': 'Estratégias Avalanche e Snowball explicadas e comparadas',
    'landing.debt.point.snowball': 'Veja exatamente quanto você economiza vs. pagamento mínimo',
    'landing.debt.point.projection': 'Cronograma de amortização mês a mês',
    'landing.debt.point.savings': 'Dicas personalizadas para quitar mais rápido',
    'landing.debt.cta': 'Gerar meu plano de quitação →',
    'landing.debt.stat.strategy': 'Estratégia', 'landing.debt.stat.strategy_val': 'Escolhida pela IA',
    'landing.debt.stat.months': 'Prazo de quitação', 'landing.debt.stat.months_val': 'Mês a mês',
    'landing.debt.stat.interest': 'Juros economizados', 'landing.debt.stat.interest_val': 'Maximizado',
    'landing.debt.stat.schedule': 'Amortização', 'landing.debt.stat.schedule_val': 'Cronograma completo',
    'brand.slogan': 'Finanças que pensam por você — powered by AI',
    'landing.footer': '© {year} Plannizzi AI. Todos os direitos reservados.',
    /* ── Settings ── */
    'settings.title': 'Configurações da Conta', 'settings.subtitle': 'Gerencie sua conta e assinatura.',
    'settings.account': 'Informações da Conta', 'settings.name': 'Nome Completo', 'settings.email': 'E-mail',
    'settings.save': 'Salvar Alterações', 'settings.saving': 'Salvando…', 'settings.saved': 'Salvo!',
    'settings.password': 'Alterar Senha', 'settings.current_password': 'Senha Atual',
    'settings.new_password': 'Nova Senha', 'settings.confirm_password': 'Confirmar Nova Senha',
    'settings.update_password': 'Atualizar Senha',
    'settings.subscription': 'Assinatura',
    'settings.plan.free': 'Plano Gratuito', 'settings.plan.paid': 'Plano Pro',
    'settings.plan.active': 'Ativo', 'settings.plan.inactive': 'Inativo',
    'settings.plan.renews': 'Renova em', 'settings.plan.cancels': 'Cancela em',
    'settings.upgrade': 'Assinar Pro', 'settings.manage': 'Gerenciar Assinatura',
    'settings.features.free': 'Plano gratuito inclui', 'settings.features.paid': 'Plano Pro inclui',
    'feature.free.1': '1 meta financeira ativa', 'feature.free.2': '1 plano gerado por IA',
    'feature.free.3': 'Projeções básicas (1 cenário)', 'feature.free.4': 'Qualidade padrão de respostas',
    'feature.paid.1': 'Metas financeiras ilimitadas', 'feature.paid.2': 'Planos por IA ilimitados',
    'feature.paid.3': 'Projeções completas (3 cenários)', 'feature.paid.4': 'Ferramenta de simulação de investimentos',
    'feature.paid.5': 'Histórico de progresso', 'feature.paid.6': 'IA com qualidade prioritária',

    /* ── Debt ── */
    'debt.title': 'Quitar Dívidas', 'debt.new': '+ Nova Dívida',
    'debt.subtitle.paid': '{n} dívida(s) ativa(s)',
    'debt.subtitle.free': '{n} de {limit} meta(s) de dívida ativa(s)',
    'debt.empty.title': 'Nenhuma dívida cadastrada',
    'debt.empty.sub': 'Adicione uma dívida e deixe a IA criar um plano de pagamento personalizado.',
    'debt.empty.cta': 'Adicionar Dívida',
    'debt.section.active': 'Ativas', 'debt.section.completed': 'Quitadas 🎉',
    'debt.limit.title': 'Limite do plano gratuito atingido',
    'debt.limit.sub': 'Assine o Pro para dívidas ilimitadas.',
    'debt.limit.cta': 'Assinar', 'debt.limit.tooltip': 'Assine o Pro para adicionar mais dívidas',
    'debt.confirm.delete': 'Excluir "{title}"? Essa ação não pode ser desfeita.',
    'debt.confirm.complete': 'Marcar "{title}" como quitada?',
    'debt.type.credit_card': 'Cartão de Crédito', 'debt.type.personal_loan': 'Empréstimo Pessoal',
    'debt.type.student_loan': 'Financiamento Estudantil', 'debt.type.car_loan': 'Financiamento de Veículo',
    'debt.type.mortgage': 'Financiamento Imobiliário', 'debt.type.medical': 'Dívida Médica', 'debt.type.other': 'Outro',
    'debt.status.active': 'Ativa', 'debt.status.completed': 'Quitada', 'debt.status.archived': 'Arquivada',
    'debt.card.total_debt': 'Valor Total', 'debt.card.interest_rate': 'Taxa de Juros',
    'debt.card.min_payment': 'Pagamento Mín.', 'debt.card.payoff_plan': 'Tempo para Quitar',
    'debt.card.months': 'meses', 'debt.card.view_plan': 'Ver Plano →',
    'debt.card.get_plan': 'Gerar Plano IA →', 'debt.card.generating': 'Gerando…',
    'debt.card.complete': 'Marcar como Quitada',
    'debt.form.modal_title': 'Adicionar Dívida', 'debt.form.title': 'Nome',
    'debt.form.title_placeholder': 'ex: Cartão Visa',
    'debt.form.debt_type': 'Tipo de Dívida', 'debt.form.total_debt': 'Valor Total Devido',
    'debt.form.interest_rate': 'Taxa de Juros Anual (%)',
    'debt.form.minimum_payment': 'Pagamento Mínimo / mês',
    'debt.form.minimum_payment_hint': 'Deixe vazio se não souber — a IA vai calcular.',
    'debt.form.description': 'Observações (opcional)',
    'debt.form.description_placeholder': 'Contexto adicional para a IA…',
    'debt.form.submit': 'Adicionar Dívida',
    'debt.plan.back': 'Todas as Dívidas',
    'debt.plan.at_rate': 'a {rate}% de juros ao ano',
    'debt.plan.not_found': 'Meta de dívida não encontrada.',
    'debt.plan.empty.title': 'Nenhum plano ainda',
    'debt.plan.empty.sub': 'Deixe a IA analisar sua dívida e criar uma estratégia personalizada.',
    'debt.plan.generate_cta': 'Gerar Plano IA',
    'debt.plan.generating': 'Gerando…',
    'debt.plan.generating_title': 'Criando seu plano de quitação…',
    'debt.plan.generating_sub': 'Isso geralmente leva menos de 30 segundos.',
    'debt.plan.failed.title': 'Falha ao gerar o plano',
    'debt.plan.failed.sub': 'Ocorreu um erro. Por favor, tente novamente.',
    'debt.plan.retry_cta': 'Tentar Novamente',
    'debt.plan.regenerate': 'Regenerar plano',
    'debt.plan.regen_modal.title': 'Atualizar Informações da Dívida Antes de Regenerar',
    'debt.plan.strategy_label': 'Estratégia recomendada',
    'debt.plan.stat.monthly_payment': 'Pagamento Mensal',
    'debt.plan.stat.monthly_payment_sub': 'recomendado',
    'debt.plan.stat.months_to_payoff': 'Meses para Quitar',
    'debt.plan.stat.months_to_payoff_sub': '≈ {yr} anos',
    'debt.plan.stat.total_interest': 'Total de Juros',
    'debt.plan.stat.total_interest_sub': 'custo da dívida',
    'debt.plan.stat.total_paid': 'Total Pago',
    'debt.plan.stat.total_paid_sub': 'principal + juros',
    'debt.plan.summary.title': 'Resumo do Plano',
    'debt.plan.recommendations.title': 'Recomendações',
    'debt.plan.warnings.title': 'Alertas de Risco',
    'debt.plan.reasoning.title': 'Raciocínio da IA',
    'debt.plan.table.title': 'Cronograma de Pagamento',
    'debt.plan.table.months_total': 'meses no total',
    'debt.plan.table.month': 'Mês',
    'debt.plan.table.payment': 'Pagamento',
    'debt.plan.table.principal': 'Principal',
    'debt.plan.table.interest': 'Juros',
    'debt.plan.table.balance': 'Saldo',
    'debt.plan.table.show_all': 'Ver todos os {n} meses',
  },
};
